/**
 * Checks fulfillment level return eligibility from OMS to see if return button should be enabled,
 *  if no fulfillment level eligibility is found, check if at least 1 lineItem is eligible
 * @param data order details payload
 * @returns boolean that determines if return button should be displayed
 */
export var isReturnOnlineAllowed = function (fulfillmentGroup) {
    var _a, _b;
    if (fulfillmentGroup === void 0) { fulfillmentGroup = {}; }
    // search in fulfillmentGroup
    var fulfillmentReturnEligibility = (_a = fulfillmentGroup.actions) === null || _a === void 0 ? void 0 : _a.returnOnlineAllowed;
    if (fulfillmentReturnEligibility !== undefined) {
        return fulfillmentReturnEligibility;
    }
    // if fulfillment group action is not in payload, check lineItem actions
    return (_b = fulfillmentGroup.lineItems) === null || _b === void 0 ? void 0 : _b.some(function (lineItem) { var _a; return (_a = lineItem.actions) === null || _a === void 0 ? void 0 : _a.returnOnlineAllowed; });
};
